export * from './product-recommendation-item.interface';
